AUI().ready(function() {



  $("a").attr("data-senna-off","true");

    /* duplicar menu SUP */
  let menuTop = document.querySelector('.header-nav-top-list .portlet-body ul'),
      subMenuList = document.querySelector('#site-navigation ul');
  if(typeof(menuTop) != 'undefined' && menuTop != null && typeof(subMenuList) != 'undefined' && subMenuList != null){
    subMenuList.insertAdjacentElement('afterend', menuTop.cloneNode(true));
  }

  /* observer */ 
  const handler = (entries) => {

    if (entries[0].intersectionRatio === 0 && entries[0].isIntersecting === false) {
        document.body.classList.add('menuStiky');
    } else {
        document.body.classList.remove('menuStiky');
    }
  }
  // DOM element(s)
  const sentinalEl = document.querySelector('.sentinal');
  const observer = new IntersectionObserver(handler);// create the observer
  if(typeof(sentinalEl) != 'undefined' && sentinalEl != null){
    observer.observe(document.querySelector('.sentinal'));
  }




});

Liferay.Portlet.ready(

	/*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

	function(portletId, node) {
	}
);

Liferay.on(
	'allPortletsReady',

	/*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

	function() {
	}
);



// Mostrar buscador
/* function showSearch(){
    $(".header-search-btn").click(function(){
        $(".header-search-input").toggleClass("active");
        $(this).toggleClass("active");
        $(".search-general-content").removeClass("activar-search");
        $(".search-overlay").removeClass("active");
    });
} */
// Mostrar menu principal
/* function showNavMain(){
    // Mostrar primer nivel menu principal
    $(".btn-nav-bar").click(function(){
        $(this).toggleClass("active");
        $(".nav-main").toggleClass("active");
        $(".overlay-ara").toggleClass("active");
        $(".nav-main-content ul").removeClass("active");
        $(".nav-main-content ul li").removeClass("active");
        $(".nav-main-list__second-level").removeClass("move-active");
        $("html, body").animate({ scrollTop: 0 }, "fast");
    });
    // Mostrar segundo nivel menu principal

    $(".nav-main-item__first-level > a").click(function(e){
        e.preventDefault();
        $(".nav-main-item__first-level").each(function() {
            $(".nav-main-list__second-level").removeClass("move-active active");
            $(this).removeClass("active");
        });
        $(".nav-main-list__third-level").removeClass("active");
        $(".nav-main-item__third-level").removeClass("active");
        $(".nav-main-item__second-level").removeClass("active");
        $(this).parent("li.nav-main-item__first-level").addClass("active");
        $(this).siblings(".nav-main-list__second-level").addClass("active");
    });
    // Mostrar tercer nivel menu principal
    $(".nav-main-item__second-level > a").click(function(e){
        e.preventDefault();
        $(".nav-main-list__second-level").each(function() {
            $(this).removeClass("move-active active");
            $(".nav-main-item__second-level").removeClass("active");
            $(".nav-main-list__third-level").removeClass("active");
        });
        $(this).parents("ul.nav-main-list__second-level").addClass("move-active active");
        $(this).parent("li.nav-main-item__second-level").addClass("move-active active");
        $(this).siblings(".nav-main-list__third-level").addClass("active");
        $(this).siblings(".nav-main-list__third-level .nav-main-item__third-level").addClass("active");
    });
} */

// Carrusel destacados
function carouselHighlights(){
    $('.highlights-content-carousel').slick({
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '5%'
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '5%'
            }
          }
        ]
      });
}

// Carrusel Agenda
function carouselSchedule(){
    $('.schedule-content-carousel').slick({
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '5%'
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '5%'
            }
          }
        ]
      });
}

// Carrusel Igualdad
function carouselContent(){
  $('.general-content-carousel').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1
    });
}
// Slider
function carouselSlider(){
  $('.slider-content-carousel').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}

// Mostrar todos los filtros
function showAllFilter(){
  $(".filter-procedure-content .list-unstyled").each(function(idx) {
    var itemsFilter = $('.facet-value',this).length;
    if(itemsFilter > 5){
      $('<section class="filter-btn__show-all"><span id="showAll">'+Liferay.Language.get('view-more')+'</span></section>').appendTo(this);
    }
    $(this).children(".facet-value").each(function(elem) {
      $(this).css("display", "block");
      if(elem > 4 ){
        $(this).css("display", "none");
      }
    });
  });
  $(".filter-btn__show-all").click(function(){
    $(this).siblings(".filter-procedure-content .list-unstyled .facet-value").show("1000");
    $("span", this).addClass("hidden");
  });
}

// Mostrar filtros movil
function showFilterMobile(){
    var screenWidth = window.innerWidth;
    if(screenWidth < 992){
        if($("#btnFilterProcedure").length == 0){
            $('<span class="btn-filter__mobile" id="btnFilterProcedure">Filtro <span class="icon-ara-desplegable"></span></span>').prependTo(".filter-procedure-content");
            $(".btn-filter__mobile").click(function(){
                $(this).parent(".filter-procedure-content").toggleClass("filter-active-mobile");
            });
        }
    }
}

// Carrusel igualdad
function noCarouselMobile(){
  var screenWidth = window.innerWidth;
  var widthCarousel = screenWidth - 30;
  var widthSlick = $(".slick-track").width();
  var widthSlide = $(".slick-slide").width();
  if(screenWidth <= 768){
    $(".carousel-content-general .draggable").removeClass("slick-list");
    $(".carousel-content-general .draggable > div").removeClass("slick-track");
    $(".carousel-content-general .draggable").css("width", widthCarousel);
    $(".carousel-content-general .general-content-carousel").addClass("carousel-content-height");
  }
  else {
    $(".carousel-content-general .draggable").addClass("slick-list");
    $(".carousel-content-general .draggable > div").addClass("slick-track");
    $(".carousel-content-general .general-content-carousel").removeClass("carousel-content-height");
    $(".carousel-content-general .draggable").css("width", "100%");
    $(".carousel-content-general .draggable .slick-track").css("width", widthSlick);
    $(".carousel-content-general .draggable .slick-slide").css("width", widthSlide);
  }
}

// Mostrar item del carrusel general
function showItemCarousel(){
  $(".carousel-content__btn .btn").click(function(){
    $(".carousel-content-general .general-content-carousel").toggleClass("carousel-height-auto");
    $(this).text(function(i, v){
      return v === 'Mostrar más' ? 'Mostrar menos' : 'Mostrar más'
   })
  });
}
// Mostrar cuadro de resultado de buscador
function showBoxResultsSearch(){
  $(".header-search-input").keypress(function(e) {
    if(e.which == 13) {
       // Acciones a realizar, por ej: enviar formulario.
      $(".search-general-content").addClass("activar-search");
      $(".search-overlay").addClass("active");
    }
 });
}

// Mostrar más temas servicios más solicitados
function showMoreServices(){
  var screenWidth = window.innerWidth;
  $(".services-requested-row .services-requested-item").each(function(index) {
    $(this).css("display", "block");
    if(screenWidth > 1024){
      if(index > 7 ){
        $(this).css("display", "none");
		$("#mostrarTemas").css("display", "block");
        $("#mostrarTemas").show();
      }
    }
    else if(screenWidth < 1024 && screenWidth > 768){
      if(index > 3 ){
        $(this).css("display", "none");
		$("#mostrarTemas").css("display", "block");
        $("#mostrarTemas").show();
      }
    }
    else {
      if(index > 2 ){
        $(this).css("display", "none");
		$("#mostrarTemas").css("display", "block");
        $("#mostrarTemas").show();
      }
    }
  });
  $("#mostrarTemas").click(function(){
    $(".services-requested-row .services-requested-item").show("1000");
    $(this).hide();
  });
}

// Agregar clases para activar primer elemento del tab horizontal
function addClassFirstTab(){
  $(".content-tabs__horizontal .nav-tabs li:first-child a").addClass("active");
  $(".content-tabs__horizontal .nav-tabs li:first-child a").attr("aria-selected","true");
  $(".content-tabs__horizontal .tab-content > div").first().addClass("active show");
}

// Modificar estilos al hacer check en los filtros de tramites
function addClassCheckbox(){
  $(".list-unstyled input[type=checkbox]").each(function() {
    if( $(this).prop('checked') ) {
      $(this).parent("label").addClass("checked");
    }
    else {
      $(this).parent("label").removeClass("checked");
    }
  });
}
$('.list-unstyled input[type=checkbox]').change(addClassCheckbox);

// Mostrar más tramites online
function showTramitesOnline(){
  var screenWidth = window.innerWidth;
  $(".online-procedures-row .online-procedures-row__items").each(function(index) {
    $(this).css("display", "block");
    if(screenWidth < 768){
      if(index > 2 ){
        $(this).css("display", "none");
        $("#btnTramitesOnline").css("display", "block");
      }
    }
    else {
      $("#btnTramitesOnline").css("display", "none");
    }
  });
  $("#btnTramitesOnline").click(function(){
    $(".online-procedures-row .online-procedures-row__items").show("1000");
    $(this).addClass("hidden");
  });
}

// Cambiar img por background para ie (object-fit)
function changeImgBackground(){
  var userAgent, ieReg, ie;
  userAgent = window.navigator.userAgent;
  ieReg = /msie|Trident.*rv[ :]*11\./gi;
  ie = ieReg.test(userAgent);

  if(ie) {
    $(".banner-procedure__bg, .highlights-image, .news-primary__image, .news-secondary__image, .banner-item-content").each(function () {
      var $container = $(this),
          imgUrl = $container.find("img").prop("src");
      if (imgUrl) {
        $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
      }
    });
  }
}

// función mover 2do nivel en mega menu
function moveMenuSecondLevel(){
  var screenWidth = window.innerWidth;
  if(screenWidth > 1024){ 
    $(".nav-main-list__second-level").each(function(){
      if($(this).hasClass("active")){
        $(this).addClass("move-left");
      }
    });
  }
}

// Función custom audio
 
document.addEventListener("DOMContentLoaded", function() {

  /* EVENTOS CLIC */
  document.addEventListener('click', (e) => {
    
    /* buscador */
    if (!e.target.closest('.header-search-content') && !document.querySelector('button.btnSearch').classList.contains("collapsed")) {
      document.querySelector('button.btnSearch').click();
    }else if (e.target.closest('.btnSearch') && !document.querySelector('button.btnSearch').classList.contains("collapsed")){
      setTimeout(() => {
        document.querySelector('#collapseSearch input.input-group-inset').focus();
      }, 1000);
    }
    /* end buscador */

    /* btn menu responsive */
    /*if (e.target.closest('.hamburger')) {
        document.querySelector('button.hamburger').setAttribute('aria-expanded',!JSON.parse(document.querySelector('button.hamburger').getAttribute('aria-expanded')));
        document.querySelector('.submenu-content-v2').classList.toggle('show');
        document.body.classList.toggle('menuOpen');
        document.querySelector('html').classList.toggle('menuOpen');
    }*/
    if (e.target.closest('.hamburger')) {
        document.querySelector('button.hamburger').setAttribute('aria-expanded',!JSON.parse(document.querySelector('button.hamburger').getAttribute('aria-expanded')));
        
        let submenuElement = document.querySelector('.submenu-content-v2');
        if (!submenuElement) {
            submenuElement = document.querySelector('.header-nav-top-list');
        }
        
        if (submenuElement) {
            submenuElement.classList.toggle('show');
        }
        
        document.body.classList.toggle('menuOpen');
        document.querySelector('html').classList.toggle('menuOpen');
    }
  });
});

$(document).ready(function(){
    //showSearch();
    //showNavMain();
    carouselHighlights();
    carouselSchedule();
    showAllFilter();
    showFilterMobile();
    carouselContent();
    carouselSlider();
    noCarouselMobile();
    showBoxResultsSearch();
    showItemCarousel();
    showMoreServices();
    addClassFirstTab();
    addClassCheckbox();
    showTramitesOnline();
    changeImgBackground();
    function starEffectMenu(){
      moveMenuSecondLevel();
    };
    setTimeout(starEffectMenu, 500);
});
$(window).resize(function(){
    noCarouselMobile();
    showItemCarousel();
    //showMoreServices();
    showFilterMobile();
    addClassCheckbox();
    showTramitesOnline();
});


    